import { render, staticRenderFns } from "./ChatExportSidebar.vue?vue&type=template&id=42c810c9&scoped=true&"
import script from "./ChatExportSidebar.vue?vue&type=script&lang=js&"
export * from "./ChatExportSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChatExportSidebar.vue?vue&type=style&index=0&id=42c810c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c810c9",
  null
  
)

export default component.exports